import { render, staticRenderFns } from "./valueAddedService.vue?vue&type=template&id=0230a86c&scoped=true&"
import script from "./valueAddedService.vue?vue&type=script&lang=js&"
export * from "./valueAddedService.vue?vue&type=script&lang=js&"
import style0 from "./valueAddedService.vue?vue&type=style&index=0&id=0230a86c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0230a86c",
  null
  
)

export default component.exports